import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { ToggleInvestigationTypeActiveResult } from './toggle-investigation-type-active.result';

@Injectable({ providedIn: 'root' })
export class ToggleInvestigationTypeActiveUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(id: string, isActive: boolean): Observable<ToggleInvestigationTypeActiveResult> {
    this._state.setSavingInvestigationTypeStatus(true);
    this._state.clearError();

    return this._repository.toggleInvestigationTypeActive(id, isActive).pipe(
      map(() => {
        const investigationType = this._state.investigationTypes().find((it) => it.id === id);
        if (investigationType) {
          this._state.updateInvestigationType({ ...investigationType, isActive });
        }
        return { success: true };
      }),
      catchError((error) => {
        this._state.setError(
          error?.error?.message || error?.message || 'Failed to toggle investigation type status',
        );
        throw error;
      }),
      finalize(() => this._state.setSavingInvestigationTypeStatus(false)),
    );
  }
}
